module.exports = __webpack_public_path__ + "assets/img/3.299950c9.png";